import { render } from "./ChatComponent.vue?vue&type=template&id=5cdb221c&scoped=true"
import script from "./ChatComponent.vue?vue&type=script&lang=js"
export * from "./ChatComponent.vue?vue&type=script&lang=js"

import "./ChatComponent.vue?vue&type=style&index=0&id=5cdb221c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdb221c"]])

export default __exports__